/* eslint-disable react/no-array-index-key */

import React from 'react';
import { Field } from 'redux-form';

import Delete from 'jbc-front/components/icons/Delete';

import FCTextWrapper from './FCTextWrapper';
import styles from './EditableListFields.scss';

const EditableListFields = ({ fields, fieldName, mode, type }) => (
  <div>
    <div className={styles.head}>{type} name</div>
    {fields.map((name, index) => {
      const field = fields.get(index);
      const { isEditable = true } = field;
      return (
        <div key={index}>
          {mode === 'SHOW' || !isEditable ? (
            <div className={styles.list}>
              <p className={styles.input}>{field[fieldName]}</p>
            </div>
          ) : (
            <div className={styles.list}>
              <div className={styles.data}>
                <Field type="text" name={`${name}.${fieldName}`} component={FCTextWrapper} />
              </div>
              {field.employeesCount === undefined || field.employeesCount === 0 ? (
                <div className={styles.delete}>
                  <Delete
                    size={20}
                    onClick={e => {
                      e.preventDefault();
                      fields.remove(index);
                    }}
                  />
                </div>
              ) : (
                <div className={styles.nodelete}>
                  <Delete size={20} />
                  <div className={styles.nodeleteText}>Cannot remove because it was setted in employee infomation.<br />従業員情報で設定されているので削除できません</div>
                </div>
              )}
            </div>
          )}
        </div>
      );
    })}
  </div>
);
export default EditableListFields;
